import { TitleText } from 'text/part'
import { Article } from './types'

const HistoryArticle: Article = {
  title: TitleText.history,
  headers: { jp: ['更新日', '更新内容'], en: ['Date', 'Details'] },
  rows: {
    jp: [
      ['2021/04/02', '2020年度の活動を追加'],
      ['2020/07/08', 'スマホ対応'],
      ['2020/04/30', 'タイトル・研究・写真の追加'],
      ['2020/04/28', 'ページ作成'],
    ],
    en: [
      ['2021/04/02', 'Add activities for FY 2020'],
      ['2020/07/08', 'Sumartphone support.'],
      ['2020/04/30', 'Addition of Title, Research, and Photo items.'],
      ['2020/04/28', 'I created this webpage.'],
    ],
  },
}

export default HistoryArticle
